import React, { useEffect, useState } from "react";
import DomainSidebar from "../outbound/DomainSidebar";
import { BadgeList, Badge } from "../reporting_utils/Badge";
import RealtimeMarketTable from "./RealtimeMarketTable";
import SourceMediumPie from "./SourceMediumPie";
import TopDomainPie from "./TopDomainPie";
import { Common } from "../../utils/common";

const pageLoadingFrame = window.pageLoadingFrame;

export default function RealtimeMarket({ domainId }) {
  const [currentDomain, setCurrentDomain] = useState(
    Common.in_crm_mode() ? { value: Number(domainId) } : null
  );
  const [sidebarIsOpen, setSidebarIsOpen] = useState(false);
  const [data, setData] = useState({
    tableData: [],
    totalCalls: [{ calls: 0 }],
    totalChats: [{ chats: 0 }],
    totalLeads: [{ leads: 0 }],
    sourceMediumPie: [],
    topDomainPie: [],
    organicClicks: [{ clicks: 0 }],
    organicCalls: [{ calls: 0 }],
    organicChats: [{ chats: null }],
    organicLeads: [{ leads: 0 }],
    referralClicks: [{ clicks: 0 }],
    referralCalls: [{ calls: 0 }],
    referralChats: [{ chats: null }],
    referralLeads: [{ leads: 0 }],
  });

  useEffect(() => {
    if (!currentDomain) {
      return;
    }
    pageLoadingFrame("show");
    fetch("/realtime_market_data", {
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({ domain_id: currentDomain.value }),
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        pageLoadingFrame("hide");
      });
  }, [currentDomain]);

  return (
    <div className="report-details-container">
      {Common.in_crm_mode() ? null : (
        <DomainSidebar
          open={sidebarIsOpen}
          setOpen={setSidebarIsOpen}
          setCurrentDomain={setCurrentDomain}
        />
      )}
      {currentDomain ? (
        <>
          {Common.in_crm_mode() ? null : (
            <div className="applied-filters-container">
              <div style={{ marginBottom: "20px" }}>
                <button
                  className="btn btn-primary"
                  onClick={() => setSidebarIsOpen(!sidebarIsOpen)}
                >
                  <span className="fa fa-plus" /> Select Location
                </button>
              </div>
              <BadgeList title="Selected location">
                <Badge label={currentDomain.label} />
              </BadgeList>
            </div>
          )}

          <div>
            <div className="col-md-4">
              <div className="panel panel-default">
                <div className="panel-body padding-0">
                  <SourceMediumPie data={data.sourceMediumPie} />
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <a className="widget widget-info widget-item-icon">
                <div className="widget-item-left">
                  <span className="fa fa-phone"></span>
                </div>
                <div className="widget-data">
                  <div className="widget-title">Total Calls Today</div>
                  <div className="widget-big-int num-count">{data.totalCalls[0].calls || 0}</div>
                  <div className="widget-subtitle"></div>
                </div>
              </a>
              <a className="widget widget-info widget-item-icon">
                <div className="widget-item-left">
                  <span className="fa fa-envelope-o"></span>
                </div>
                <div className="widget-data">
                  <div className="widget-title">Total Leads Today</div>
                  <div className="widget-big-int num-count">{data.totalLeads[0].leads || 0}</div>
                  <div className="widget-subtitle"></div>
                </div>
              </a>
              <a className="widget widget-info widget-item-icon">
                <div className="widget-item-left">
                  <span className="fa fa-comments-o"></span>
                </div>
                <div className="widget-data">
                  <div className="widget-title">Total Chats Today</div>
                  <div className="widget-big-int num-count">{data.totalChats[0].chats || 0}</div>
                  <div className="widget-subtitle"></div>
                </div>
              </a>
            </div>

            <div className="col-md-4">
              <div className="panel panel-default">
                <div className="panel-body padding-0">
                  <TopDomainPie data={data.topDomainPie} />
                </div>
              </div>
            </div>

            <div className="col-md-12" style={{ marginBottom: "15px" }}>
              <RealtimeMarketTable tableData={data.tableData} />
            </div>

            <div className="col-md-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h1 className="panel-title">Organic</h1>
                </div>
                <div className="panel-body">
                  <div className="col-md-3">
                    <a className="tile tile-primary not_clickable">
                      <div className="widget-int num-count">
                        {data.organicClicks[0].clicks || 0}
                      </div>
                      <p>Clicks</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-globe"></span>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a className="tile tile-primary">
                      <div className="widget-int num-count">{data.organicChats[0].chats || 0}</div>
                      <p>Chats</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-comments-o"></span>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a className="tile tile-primary">
                      <div className="widget-int num-count">{data.organicCalls[0].calls || 0}</div>
                      <p>Calls</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-phone"></span>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a className="tile tile-primary">
                      <div className="widget-int num-count">{data.organicLeads[0].leads || 0}</div>
                      <p>Leads</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-envelope-o"></span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h2 className="panel-title">Referral</h2>
                </div>
                <div className="panel-body">
                  <div className="col-md-3">
                    <a className="tile tile-primary not_clickable">
                      <div className="widget-int num-count">
                        {data.referralClicks[0].clicks || 0}
                      </div>
                      <p>Clicks</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-globe"></span>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a className="tile tile-primary">
                      <div className="widget-int num-count">{data.referralChats[0].chats || 0}</div>
                      <p>Chats</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-comments-o"></span>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a className="tile tile-primary">
                      <div className="widget-sm-int num-count">
                        {data.referralCalls[0].calls || 0}
                      </div>
                      <p>Calls</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-phone"></span>
                      </div>
                    </a>
                  </div>
                  <div className="col-md-3">
                    <a className="tile tile-primary">
                      <div className="widget-int num-count">{data.referralLeads[0].leads || 0}</div>
                      <p>Leads</p>
                      <div className="informer informer-default dir-tr">
                        <span className="fa fa-envelope-o"></span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal fade" id="drill" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                      x
                    </button>
                    <h3 className="modal-title"></h3>
                  </div>
                  <div className="modal-body"></div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary " data-dismiss="modal">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div style={{ marginTop: "50px" }} className="text-center">
          <h4>No location selected</h4>
          <p>Get started running your report by selecting a location</p>
          <div>
            <button className="btn btn-primary" onClick={() => setSidebarIsOpen(true)}>
              <span className="fa fa-plus" /> Select Location
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
